
export const SYNCHRONOUS_CHANGE_PARENT = "SYNCHRONOUS_CHANGE_PARENT"
export const SYNCHRONOUS_CHANGE_GLOBAL_PRIORITY = "SYNCHRONOUS_CHANGE_GLOBAL_PRIORITY";
export const SYNCHRONOUS_CHANGE_SIBLING_POSITION = "SYNCHRONOUS_CHANGE_SIBLING_POSITION";
export const SYNCHRONOUS_CHANGE_TODO_PRIORITY = "SYNCHRONOUS_CHANGE_TODO_PRIORITY";
export const SYNCHRONOUS_ORDER_SIBLINGS = "SYNCHRONOUS_ORDER_SIBLINGS";

export const changeGlobalPrioritySynchronously = (orderedChildren) => ({
    type: SYNCHRONOUS_CHANGE_GLOBAL_PRIORITY,
    payload: { orderedChildren },
});

export const changeTodoPrioritySynchronously = (taskId, newPriority) => ({
    type: SYNCHRONOUS_CHANGE_TODO_PRIORITY,
    payload: { taskId, newPriority },
});

export const changeParentSynchronously = (movedTaskId, destinationProjectId, sourceProjectId, nearestTaskId, destinationIndex) => ({
    type: SYNCHRONOUS_CHANGE_PARENT,
    payload: { movedTaskId, destinationProjectId, sourceProjectId, nearestTaskId, destinationIndex },
});

export const changeSiblingPositionSynchronously = (movedProjectId, newIndex) => ({
    type: SYNCHRONOUS_CHANGE_SIBLING_POSITION,
    payload: { movedProjectId, newIndex },
});

// Optimistic update for reordering children within a parent (Overview page tasks)
export const orderSiblingsSynchronously = (parentId, orderedIds) => ({
    type: SYNCHRONOUS_ORDER_SIBLINGS,
    payload: { parentId, orderedIds },
});
